import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Profile() {
  const { user, setUser } = useAuth();
  const [form, setForm] = useState({ name: "" });
  const [saving, setSaving] = useState(false);
  const [pw, setPw] = useState({ current_password: "", new_password: "" });
  const [pwBusy, setPwBusy] = useState(false);

  useEffect(() => {
    if (user) setForm({ name: user.name || "" });
  }, [user]);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.post("/auth/profile", form);
      if (data.user && setUser) setUser(data.user);
      toast.success("Profile updated.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Update failed.");
    } finally {
      setSaving(false);
    }
  };

  const changePassword = async (e) => {
    e.preventDefault();
    setPwBusy(true);
    try {
      await api.post("/auth/change-password", pw);
      toast.success("Password updated.");
      setPw({ current_password: "", new_password: "" });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Change failed.");
    } finally {
      setPwBusy(false);
    }
  };

  if (!user) return <div style={{ padding: 80, textAlign: "center", color: "var(--text-muted)" }}>Loading…</div>;

  return (
    <div style={{ maxWidth: 640, margin: "60px auto", padding: "0 24px" }} data-testid="profile-page">
      <div style={{ fontSize: 11, letterSpacing: "0.3em", color: "var(--gold)", marginBottom: 8 }}>YOUR ACCOUNT</div>
      <h1 className="serif" style={{ fontSize: 36, color: "#fff", margin: "0 0 28px", fontWeight: 400 }}>Profile & Security</h1>

      <div className="bg-card" style={{ padding: 24, marginBottom: 22 }}>
        <div style={{ fontSize: 11, letterSpacing: "0.3em", color: "var(--gold)", marginBottom: 16 }}>PERSONAL INFO</div>
        <form onSubmit={save} style={{ display: "grid", gap: 14 }}>
          <div>
            <label className="label-dark">Full name</label>
            <input data-testid="profile-name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} className="input-dark" />
          </div>
          <div>
            <label className="label-dark">Email</label>
            <input value={user.email} disabled className="input-dark" style={{ opacity: 0.6 }} />
            <div className="muted" style={{ fontSize: 11, marginTop: 4 }}>Email can&apos;t be changed here. Contact support if you need to switch addresses.</div>
          </div>
          <button data-testid="profile-save" type="submit" disabled={saving} className="btn-gold" style={{ marginTop: 4, justifySelf: "start", padding: "12px 22px" }}>
            {saving ? "Saving…" : "Save changes"}
          </button>
        </form>
      </div>

      <div className="bg-card" style={{ padding: 24, marginBottom: 22 }}>
        <div style={{ fontSize: 11, letterSpacing: "0.3em", color: "var(--gold)", marginBottom: 16 }}>CHANGE PASSWORD</div>
        <form onSubmit={changePassword} style={{ display: "grid", gap: 14 }}>
          <div>
            <label className="label-dark">Current password</label>
            <input data-testid="profile-current-pw" required type="password" value={pw.current_password} onChange={e => setPw({ ...pw, current_password: e.target.value })} className="input-dark" />
          </div>
          <div>
            <label className="label-dark">New password</label>
            <input data-testid="profile-new-pw" required type="password" minLength={6} value={pw.new_password} onChange={e => setPw({ ...pw, new_password: e.target.value })} className="input-dark" placeholder="At least 6 characters" />
          </div>
          <button data-testid="profile-change-pw" type="submit" disabled={pwBusy} className="btn-ghost" style={{ marginTop: 4, justifySelf: "start", padding: "12px 22px" }}>
            {pwBusy ? "Updating…" : "Update password"}
          </button>
        </form>
      </div>

      <div style={{ textAlign: "center", marginTop: 28 }}>
        <Link to="/dashboard" className="link-gold">← Back to dashboard</Link>
      </div>
    </div>
  );
}
